import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useUser();
  const { showLoginModal } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        showLoginModal();
      } else if (user.role !== 'admin') {
        navigate('/');
      }
    }
  }, [loading, user, showLoginModal, navigate]);

  // 如果正在加载用户信息，显示空内容
  if (loading) {
    return null;
  }

  // 如果用户未登录或不是管理员，显示空内容
  if (!user || user.role !== 'admin') {
    return null;
  }

  // 如果用户是管理员，显示受保护的路由内容
  return children;
};

export default AdminRoute; 